import React from "react";
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import GIEButton from '../GIEButton/GieButton';
import greyWarning from '../../assets/img/icons/greyWarning.svg';
import logo from "../../assets/gie.png";
import './Header.css';
import GIESvgIcon from "../GIEIcon/GIESvgIcon";

class SideBarContent extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      openMyAccount: false
    }
  }

  redirect = (endUrl: string) => {
    window.location.href = '/admin/' + endUrl
  }

  openAccount = (event) => {
    this.setState({openMyAccount: !this.state.openMyAccount});
  }

  close = () => {
    this.props.close()
  }

  render() {
    return (
      <div>
        <div className="d-flex align-items-center gap-3 m-3 mb-5">
          <div onClick={this.close}>
            <CloseRoundedIcon className="close-icon"/>
          </div>
          <a href="/admin/accueil" className="header-logo">
            <img alt='https://gie-sa.fr/' src={logo} height="60"/>
          </a>
        </div>
        {!this.state.openMyAccount ?
          (<div>
            <div>
              <a href="/admin/formulaire-d-urgence" className="w-100">
                <GIEButton classes={{root: 'white-btn'}} styleClass="w-100 text-center">
                  <div className="d-flex align-items-center gap-2">
                    <GIESvgIcon icon={greyWarning}/>
                    <span>SIGNALER UNE PANNE</span>
                  </div>
                </GIEButton>
              </a>

              <div className="d-flex flex-column gap-3 align-items-center p-3">
                <a href="/admin/services" className="w-100">
                  <GIEButton classes={{root: 'blue-btn'}} styleClass="w-100">
                    <span>Services en ligne</span>
                    <KeyboardArrowRightIcon/>
                  </GIEButton>
                </a>
                <GIEButton onClick={this.openAccount} classes={{root: 'orange-btn'}} styleClass="w-100">
                  Mon compte
                </GIEButton>
              </div>
            </div>
          </div>) :
          (<div>
              <div className="p-3">
                <a href="documents" className="mobile-menu">
                  <span>MES DOCUMENTS</span>
                  <KeyboardArrowRightIcon/>
                </a>
                <a href="mes-informations" className="mobile-menu">
                  <span>MES INFORMATIONS</span>
                  <KeyboardArrowRightIcon/>
                </a>
                <a href="login" className="mobile-menu">
                  <span>DECONNEXION</span>
                  <KeyboardArrowRightIcon/>
                </a>
                <GIEButton onClick={this.openAccount} classes={{root: 'orange-btn'}} styleClass="w-100 mt-4">
                  <KeyboardArrowLeftIcon/>
                  <span>Retour</span>
                </GIEButton>
              </div>
            </div>
          )}
      </div>
    )
  }
}

export default SideBarContent;
